import { BaseModel } from "model/BaseModel";

export default class Local implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    descricao: string;
    ativo: boolean;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        descricao = '',
        ativo = true
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.descricao = descricao;
        this.ativo = ativo;
    }
}